import React, { Component } from 'react';
import { connect } from 'react-redux';
import createSelector from 'helpers/createSelector';
import _ from 'lodash';
import classnames from 'classnames';

import { updateQuery } from 'modules/router/actions';

const container = connect(
  createSelector(
    (state) => ({
      query: _.get(state, 'router.location.query'),
      subjects: _.get(state, 'subject.entities'),
      mediaTypeById: _.get(state, 'mediaType.mediaTypeById'),
      mediaTypeIds: _.get(state, 'mediaType.mediaTypeIds'),
      sourceGroup: _.get(state, 'sourceGroup.entities'),
      sourceGroupById: _.get(state, 'sourceGroup.byId'),
      pathname: _.get(state, 'router.location.pathname'),
    }),
    (state) => {
      const { query, mediaTypeById, mediaTypeIds, sourceGroup, pathname, subjects, sourceGroupById } = state;
      const routes = pathname.split('/');
      const subjectId = query.subjectId;
      const subject = subjects[subjectId];
      let mediaTypes = _.intersection(
        mediaTypeIds,
        _.keys(_.get(subject,'queries')),
      );
      const module = routes[4];
      const modules = ['sample', 'testing', 'recycle']
      if (_.includes(modules, module)) {
        mediaTypes = _.keys(_.get(subject,'queries'))
      }
      mediaTypes = _.sortBy(mediaTypes, (n) => {
        return _.indexOf(mediaTypeIds, n)
      })
      const mediaTypeId = _.includes(mediaTypes, query.mediaType)
        ? query.mediaType
        : null;
      const sourceGroupId = _.get(query, 'sourceGroupId');
      return ({
        mediaTypeId,
        mediaTypes,
        sourceGroupId,
        sourceGroup,
        sourceGroupById
      })
    }
  )
)

class MediaTypePanel extends Component {

  render() {
    const { dispatch, mediaTypeId, mediaTypes, sourceGroupId, sourceGroup, sourceGroupById } = this.props;
    return (
      <div className="query-panel-header">
      {mediaTypes.length > 1  &&
          <div
            className={classnames("query-label", {
              active: !mediaTypeId,
            })}
            onClick={() => {
              dispatch(updateQuery({mediaType: [], from: [], in: [], sourceGroupId: []}))
            }}
          >{t('commonAll')}</div>
        }
        {
          _.map(mediaTypes, (type) =>
            <div
              className={classnames("query-label", {
                active: type === mediaTypeId || mediaTypes.length === 1,
              })}
              key={type}
              onClick={() => {
                if (!_.isEmpty(sourceGroupId)) {
                  const source = _.get(sourceGroupById[sourceGroupId], 'name');
                  const sourceGroupMediaType = sourceGroup[type];
                  const sourceId = _.get(sourceGroupMediaType[source], 'id');
                  if (!_.isEmpty(sourceId)) {
                    dispatch(updateQuery({mediaType: type, from: [], in: [], sourceGroupId: [sourceId]}))
                  } else {
                    dispatch(updateQuery({mediaType: type, from: [], in: [], sourceGroupId: []}))
                  }
                } else {
                  dispatch(updateQuery({mediaType: type, from: [], in: [], sourceGroupId: []}))
                }
              }}
            >
              {t(type)}
            </div>
          )
        }
      </div>
    )
  }
}

export default container(MediaTypePanel);



/** WEBPACK FOOTER **
 ** ./src/app/modules/controlPanel/components/MediaTypePanel.js
 **/